import { render, staticRenderFns } from "./AssistResult.vue?vue&type=template&id=71388d5a&scoped=true&"
import script from "./AssistResult.vue?vue&type=script&lang=js&"
export * from "./AssistResult.vue?vue&type=script&lang=js&"
import style0 from "./AssistResult.vue?vue&type=style&index=0&id=71388d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71388d5a",
  null
  
)

export default component.exports